import {useEffect, useState} from 'react';

type UseReadLocalImage = (params: {imageFile: File | null}) => string | null;

export const useReadLocalImage: UseReadLocalImage = ({imageFile}) => {
  const [localImageFileSrc, setLocalImageFileSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!imageFile) {
      setLocalImageFileSrc(null);
      return;
    }

    var reader = new FileReader();

    const readerSetImageFile = () => {
      setLocalImageFileSrc(reader.result as string);
    };

    reader.onload = readerSetImageFile;

    reader.readAsDataURL(imageFile);

    return () => {
      reader.onload = null;
    };
  }, [imageFile]);

  return localImageFileSrc;
};
